module.exports = __webpack_public_path__ + "resources/img/img_netbackup.0ec6f1609c5a25f643e73c1550ae0a08.png";